// MVP のミニマムルーター。pathname を見て:
//  - /              → Login (未ログイン誘導)
//  - /login         → Login
//  - /dashboard     → Dashboard
//  - /reports/:id   → Report
// React Router を入れずに lightweight に保つ。

import { type ReactElement } from 'react';
import { DEFAULT_LOCALE } from '@solo-webinar-copilot/i18n';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';
import { Dashboard } from './Dashboard.tsx';
import { Login } from './Login.tsx';
import { Report } from './reports/Report.tsx';

export function App(): ReactElement {
  const path = typeof window !== 'undefined' ? window.location.pathname : '/';
  const locale = DEFAULT_LOCALE;

  let view: ReactElement;
  const reportMatch = /^\/reports\/([^/?#]+)/.exec(path);
  if (reportMatch) {
    const sessionId = decodeURIComponent(reportMatch[1]!);
    view = <Report sessionId={sessionId} locale={locale} />;
  } else if (path === '/dashboard') {
    view = <Dashboard locale={locale} />;
  } else if (path === '/login' || path === '/') {
    view = <Login locale={locale} />;
  } else {
    view = (
      <main data-testid="not-found">
        <h1>404</h1>
      </main>
    );
  }

  return <ErrorBoundary>{view}</ErrorBoundary>;
}
